/**
 * Icon Mapping for Case Phases
 * 
 * Maps phase keys from src/config/phases.ts to Lucide icons
 * Used by PrimarySidebar to auto-generate navigation entries
 * 
 * Per Day 4: This ensures phase definitions are single source of truth
 * Adding a new phase to PHASES array will auto-generate sidebar entry
 */

import {
  FileText,
  BookOpen,
  Calendar,
  Sparkles,
  Clock,
  Image,
  FolderOpen,
  Paperclip,
  ClipboardList,
  Pencil,
  BarChart3,
  Inbox,
  MessageCircle,
  Share2,
  Users,
  Settings,
  Download,
  Wrench,
  ScanLine,
  Files,
  Key,
  Calculator,
} from 'lucide-react';
import type { PhaseKey } from './phases';

/**
 * Maps phase keys to Lucide React icon components
 */
export const PHASE_ICONS: Record<PhaseKey, typeof FileText> = {
  filings: FileText,
  journal: BookOpen,
  chronology: Calendar, // Case History
  suggestions: Sparkles, // AI Suggestions
  timeline: Clock,
  exhibits: Image, // Evidence
  discovery: FolderOpen,
  attachments: Paperclip,
  calendar: ClipboardList,
  forms: FileText,
  drafts: Pencil,
  documents: Files, // Documents Center
  insights: BarChart3,
  inbox: Inbox,
  notifications: MessageCircle,
  share: Share2,
  members: Users,
  settings: Settings,
  exports: Download,
  toolkits: Wrench,
  scan: ScanLine,
  "key-details": Key,
  estimator: Calculator,
};
